import { renderMessageBox } from "../../../../TokenProcessing/TokenProcessing";
import { AxiosRequest } from "../../../../Url";
import { checkDocsSettings } from "../../../Tools/Tools";

type DocumentStateSource = {
  saveState: () => Record<string, unknown>;
  details?: {
    activeDetails?: number;
  };
};

type BeforeSaveStateOptions = {
  source: DocumentStateSource;
  dcgid?: string;
  secId?: string;
};

export const beforeSaveState = ({ source, dcgid = "", secId = "" }: BeforeSaveStateOptions) => {
  const stringState = createGridStateString(source.saveState());
  const details = source.details && source.details.activeDetails ? source.details.activeDetails : undefined;
  return saveDocumentState(dcgid, secId, stringState, details);
};

export const saveDocChanges = ({ docName, saveChanges }: { docName: string; saveChanges: () => Promise<void> }) => {
  //функция отображения сообщения, что необходимо сохранить данные перед уходом с секции
  return new Promise<boolean>((resolve) => {
    const {
      save: { checked },
    } = checkDocsSettings();
    if (!checked) return resolve(true);
    renderMessageBox({
      dlgType: 3,
      message: `Сохранить изменения, сделанные в документах: ${docName}?`,
      buttons: 14,
      selectF: async (e) => {
        const value = e.currentTarget.value;
        if (value === "2") return resolve(false);

        if (value === "6") {
          //Клик "Да"
          await saveChanges();
        }
        return resolve(true);
      },
    });
  });
};

export async function getImageHint(doccfgId: string, index: string, docId: string) {
  const params = new Map();
  params
    .set("prefix", "documents")
    .set("comand", "GetImageHint")
    .set("DocCfgID", doccfgId)
    .set("ImageIndex", index)
    .set("DocID", docId)
    .set("smart", "1");
  const json = (await AxiosRequest(true, params)) as { Text: string };
  return json.Text;
}

export function saveDocumentState(doccfgId: string, id: string, state: unknown, activeDetails?: number) {
  if (state) {
    const params = new Map();
    params
      .set("prefix", "documents")
      .set("comand", "SaveDocumentState")
      .set("DocCfgID", doccfgId)
      .set("SectionID", id)
      .set("ActiveDetail", activeDetails ? activeDetails + 1 : 0);
    return AxiosRequest(true, params, { GridState: state });
  }
}

export function createGridStateString(gridState: Record<string, unknown>) {
  if (gridState) {
    let FinalStr = "";
    let valueForString;
    for (const [key, value] of Object.entries(gridState)) {
      if (value) {
        if (typeof value === "object") {
          valueForString = `${key}=`;
          for (const [keyPoint, data] of Object.entries(value)) {
            if (keyPoint === "9") {
              valueForString += `${data}`;
            } else {
              valueForString += `${data}•`;
            }
          }
        } else {
          valueForString = `${key}=${value}`;
        }
        FinalStr += valueForString + "\r\n";
      }
    }
    //
    return FinalStr;
  }
}

export const parseGridState = (gridState: string) => {
  if (!gridState) return;

  const result: Record<string, string | Record<string, string> | undefined> = {};
  for (const value of gridState.split("\r\n")) {
    if (!value) continue;

    const [key, stateValue] = value.split("=");
    result[key] =
      stateValue?.includes("•") === true
        ? Object.fromEntries(stateValue.split("•").map((item, index) => [String(index), item]))
        : stateValue;
  }
  return result;
};
